import { Space, Typography } from "antd"
import CountryFlag from "../../../ui/CountryFlag"
import { CountryCodes } from "../../../types/amazonAds"

const { Text } = Typography

const PrimaryAsin: React.FC<{ countryCode: CountryCodes; asin?: string }> = ({
  countryCode,
  asin,
}) => {
  return (
    <Space>
      <CountryFlag countryCode={countryCode} />
      <Text>{asin}</Text>
    </Space>
  )
}

export default PrimaryAsin
